(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ga-pest-navigation"] && !Shopify.designMode) return;
  try {
    function initGaPestNavigation(scope) {
    scope.querySelectorAll('[data-ga-pest-nav]').forEach((panel) => {
      if (panel.dataset.gaReady) return;
      panel.dataset.gaReady = 'true';
      const input = panel.querySelector('[type="search"]');
      const clear = panel.querySelector('[data-pest-clear]');
      const count = panel.querySelector('[data-pest-count]');
      const empty = panel.querySelector('[data-pest-empty]');
      const groups = [...panel.querySelectorAll('[data-pest-group]')];
      const normalize = (value) => value.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
      const entries = groups.flatMap((group) => [...group.querySelectorAll('[data-pest-item]')].map((item) => ({ item, text: normalize(item.textContent + ' ' + item.dataset.pestAliases + ' ' + group.dataset.groupName) })));
      const filter = () => {
        const terms = normalize(input.value).split(/\s+/).filter(Boolean);
        let total = 0;
        entries.forEach(({ item, text }) => {
          item.hidden = !terms.every((term) => text.includes(term));
          if (!item.hidden) total += 1;
        });
        groups.forEach((group) => { group.hidden = ![...group.querySelectorAll('[data-pest-item]')].some((item) => !item.hidden); });
        empty.hidden = total > 0;
        count.textContent = total === 1 ? count.dataset.countOne : count.dataset.countLabel.replace('__COUNT__', String(total));
        clear.hidden = input.value.length === 0;
      };
      input.addEventListener('input', filter);
      input.addEventListener('search', filter);
      clear.addEventListener('click', () => { input.value = ''; filter(); input.focus(); });
      panel.querySelector('form').addEventListener('submit', (event) => {
        event.preventDefault();
        const first = entries.find(({ item }) => !item.hidden);
        if (first) first.item.querySelector('a').focus();
      });
      filter();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initGaPestNavigation(document));
  else initGaPestNavigation(document);
  document.addEventListener('shopify:section:load', (event) => initGaPestNavigation(event.target));
  } catch(e) { console.error(e); }
})();

})();
